// extracted by mini-css-extract-plugin
module.exports = {"localeSwitchList":"locale-switcher_localeSwitchList__ue52s"};